import {removeMonetaryMaskBr} from '../../../utils/formatMonetaryToBr'

export const buildUpdateStarRequest = (data: any): any => {
  return {
    stars: {
      ...data.map((item, index) => {
        return {
          description: item.description,
          minAmount: Number(removeMonetaryMaskBr(item.minAmount)),
          maxAmount: Number(removeMonetaryMaskBr(item.maxAmount)),
          observation: item.observation,
        }
      }),
    },
  }
}
